import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, Table } from 'react-bootstrap';
import Swal from 'sweetalert2';

const BASE_API_URL = process.env.REACT_APP_API_URL;

const SenderEmail = () => {

    const [showSenderModal, setShowSenderModal] = useState(false);
    const [fromEmail, setFromEmail] = useState("");
    const [password, setPassword] = useState("");
    const [senderEmailsData, setSenderEmailsData] = useState([]);
    const [editSenderId, setEditSenderId] = useState(null);
    const [showPassword, setShowPassword] = useState(false);

    // ================= FETCH =================
    const fetchSenderEmails = async () => {
        try {
            const res = await axios.get(`${BASE_API_URL}/sender/list`);
            setSenderEmailsData(res.data || []);
        } catch (err) {
            console.error("Fetch sender error:", err);
        }
    };

    useEffect(() => {
        fetchSenderEmails();
    }, []);

    // ================= SAVE =================
    const handleAddSenderEmail = async () => {
        if (!fromEmail || !password) {
            alert("Please enter both email and password");
            return;
        }

        const payload = {
            email: fromEmail,
            password: password,
        };

        try {
            if (editSenderId) {
                await axios.put(`${BASE_API_URL}/sender/${editSenderId}`, payload);
            } else {
                await axios.post(`${BASE_API_URL}/sender/add`, payload);
            }

            fetchSenderEmails();
            handleCloseSenderModal();

        } catch (err) {
            console.error("Save sender error:", err);
            alert("Failed to save sender");
        }
    };

    // ================= EDIT =================
    const handleEditSender = (item) => {
        setFromEmail(item.email);

        // ⚠️ NEVER trust backend password
        setPassword(item.password);

        setEditSenderId(item.id);
        setShowSenderModal(true);
    };

    // ================= DELETE =================

    const handleDeleteSender = async (id) => {

        const result = await Swal.fire({
            title: "Are you sure?",
            text: "This sender email will be deleted!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#6c757d",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel"
        });

        if (result.isConfirmed) {
            try {
                await axios.delete(`${BASE_API_URL}/sender/${id}`);

                // ✅ success alert
                Swal.fire({
                    title: "Deleted!",
                    text: "Sender email deleted successfully.",
                    icon: "success",
                    timer: 1500,
                    showConfirmButton: false
                });

                fetchSenderEmails();

            } catch (err) {
                console.error("Delete sender error:", err);

                // ❌ error alert
                Swal.fire({
                    title: "Error!",
                    text: "Failed to delete sender email.",
                    icon: "error"
                });
            }
        }
    };

    // ================= CLOSE =================
    const handleCloseSenderModal = () => {
        setShowSenderModal(false);
        setFromEmail("");
        setPassword("");
        setEditSenderId(null);
        setShowPassword(false);
    };

    return (
        <div className="p-3 border rounded bg-light">

            {/* HEADER */}
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h5>Sender Emails</h5>
                <Button onClick={() => setShowSenderModal(true)}>
                    + Add From Email
                </Button>
            </div>

            {/* TABLE */}
            <Table striped bordered hover responsive>
                <thead className="table-dark">
                    <tr>
                        <th>Email</th>
                        <th>Password</th>
                        <th>Action</th>
                    </tr>
                </thead>

                <tbody>
                    {senderEmailsData.length > 0 ? (
                        senderEmailsData.map((item) => (
                            <tr key={item.id}>
                                <td>{item.email}</td>
                                <td>********</td>
                                <td>
                                    <Button
                                        size="sm"
                                        variant="warning"
                                        className="me-2"
                                        onClick={() => handleEditSender(item)}
                                    >
                                        Edit
                                    </Button>

                                    <Button
                                        size="sm"
                                        variant="danger"
                                        onClick={() => handleDeleteSender(item.id)}
                                    >
                                        Delete
                                    </Button>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="3" className="text-center text-muted">
                                No sender emails found
                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>

            {/* MODAL */}
            <Modal show={showSenderModal} onHide={handleCloseSenderModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {editSenderId ? "Edit Sender Email" : "Add Sender Email"}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Form>

                        <Form.Group className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                value={fromEmail}
                                onChange={(e) => setFromEmail(e.target.value)}
                                readOnly={!!editSenderId}
                            />
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Password</Form.Label>

                            <div className="d-flex">
                                <Form.Control
                                    type={showPassword ? "text" : "password"}
                                    value={password}
                                    placeholder="Enter password"
                                    onChange={(e) => setPassword(e.target.value)}
                                />

                                <Button
                                    type="button"   // ✅ IMPORTANT FIX
                                    variant="outline-secondary"
                                    className="ms-2"
                                    onClick={() => setShowPassword(!showPassword)}
                                >
                                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                                </Button>
                            </div>

                        </Form.Group>

                    </Form>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseSenderModal}>
                        Close
                    </Button>

                    <Button variant="success" onClick={handleAddSenderEmail}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default SenderEmail;